import { render, staticRenderFns } from "./ScormView.vue?vue&type=template&id=099c0aa0&"
import script from "./ScormView.vue?vue&type=script&lang=ts&"
export * from "./ScormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports